import React, { Fragment, useEffect, useState } from "react"
import { Row, Col, Form, Button } from 'reactstrap'
import PropTypes from 'prop-types'
import { useSelector } from 'react-redux'
import { useForm } from 'react-hook-form'
import _ from "lodash"
import '@styles/react/libs/react-select/_react-select.scss'
/* ******************************************************** */
import { trans, API } from '@utils'
import { ButtonSpinner } from "@src/components"
import { CanCall } from "@modules/user"
import CardInfo from "./CardInfo"
/* ******************************************************** */

const _getSettings = (url, callback, callbackErr) => {
	API.get(url)
		.then(function ({ data }) {
			callback(data)
		})
		.catch(function (res) {
			callbackErr(res)
		})
}

const _saveSettings = (url, data, callback, callbackErr) => {
	API.post(url, { ...data })
		.then(function ({ data }) {
			callback(data)
		})
		.catch(function ({ data }) {
			callbackErr(data.data)
		})
}

const Settings = ({ getDataUrl, saveDataurl, saveDataPermission, inputSize }) => {
	const loading = useSelector(state => state.app.loading)
	const [valErrors, setValErrors] = useState({})
	const [settingsData, setSettingsData] = useState({})

	useEffect(() => {
		_getSettings(
			getDataUrl,
			(data) => {
				setSettingsData(data)
			},
			() => { }
		)
	}, [])


	const { handleSubmit, control, errors, register, unregister, setValue } = useForm()

	const onSubmit = (data) => {
		const temp_data = { ...data }
		_.forEach(temp_data.settings_temp, (item, key) => {
			if (Array.isArray(item)) {
				temp_data.settings[key] = _.map(temp_data.settings_temp[key], x => x.value)
			} else if (typeof item === 'object') {
				temp_data.settings[key] = temp_data.settings_temp[key].value
			} else {
				temp_data.settings[key] = temp_data.settings_temp[key]
			}
		})
		delete temp_data.settings_temp
		// console.log(temp_data)
		if (!_.isEmpty(errors)) {
			return
		}
		setValErrors({})
		_saveSettings(
			saveDataurl,
			temp_data,
			(d) => {
				_getSettings(
					getDataUrl,
					(data) => {
						setSettingsData(data)
					}
				)
			},
			(err) => {
				if (err) {
					const arr = {}
					for (const f in err) {
						if (err[f] !== null) arr[f] = err[f][0]
					}
					// console.log(err)
					setValErrors(arr)
				}
			}
		)
	}

	return (
		<Fragment>
			<Form action='/' onSubmit={handleSubmit(onSubmit)}>
				{_.map(settingsData, (item, index) => {
					return <CardInfo key={index} form={{ control, errors, register, unregister, setValue, valErrors }} data={item} inputSize={inputSize} />
				})}
				<CanCall action={saveDataPermission}>
					<Row>
						<Col sm='3'>
							<Button type='submit' block color='primary' disabled={loading}>
								{loading ? <ButtonSpinner /> : null}
								<span>{trans('gen.actions.save')}</span>
							</Button>
						</Col>
					</Row>
				</CanCall>
			</Form>
		</Fragment>
	)
}

Settings.propTypes = {
	getDataUrl: PropTypes.string.isRequired,
	saveDataurl: PropTypes.string.isRequired,
	saveDataPermission: PropTypes.string.isRequired,
	inputSize: PropTypes.number
}

export default Settings
